import { useQuery } from '@tanstack/react-query';
import {
  fetchDailyPickup,
  fetchMonthlyRevenue,
  fetchChannelPerformance,
  fetchPropertyPerformance,
  type DailyPickupQuery,
  type MonthlyRevenueQuery,
  type ChannelPerformanceQuery,
  type PropertyPerformanceQuery,
} from '@/services/api/reports.api';

export function useDailyPickup(query?: DailyPickupQuery) {
  return useQuery({
    queryKey: ['reports', 'daily-pickup', query],
    queryFn: () => fetchDailyPickup(query),
    staleTime: 30_000,
  });
}

export function useMonthlyRevenue(query?: MonthlyRevenueQuery) {
  return useQuery({
    queryKey: ['reports', 'monthly-revenue', query],
    queryFn: () => fetchMonthlyRevenue(query),
    staleTime: 30_000,
  });
}

export function useChannelPerformance(query?: ChannelPerformanceQuery) {
  return useQuery({
    queryKey: ['reports', 'channel-performance', query],
    queryFn: () => fetchChannelPerformance(query),
    staleTime: 30_000,
  });
}

export function usePropertyPerformance(query?: PropertyPerformanceQuery) {
  return useQuery({
    queryKey: ['reports', 'property-performance', query],
    queryFn: () => fetchPropertyPerformance(query),
    staleTime: 30_000,
  });
}

// ─── Reports Library & Statistics hooks ──────────────────────────────────────

import { useMutation } from '@tanstack/react-query';
import {
  fetchReportsLibrary,
  generateReport,
  fetchStatistics,
  type GenerateReportPayload,
  type StatisticsQuery,
} from '@/services/api/reports.api';

export function useReportsLibrary() {
  return useQuery({
    queryKey: ['reports', 'library'],
    queryFn: () => fetchReportsLibrary(),
    staleTime: 60_000,
  });
}

export function useGenerateReport() {
  return useMutation({
    mutationFn: (payload: GenerateReportPayload) => generateReport(payload),
  });
}

export function useStatistics(query: StatisticsQuery) {
  return useQuery({
    queryKey: ['reports', 'statistics', query],
    queryFn: () => fetchStatistics(query),
    enabled: !!query.propertyId,
    staleTime: 30_000,
  });
}
